import { createRouter, createWebHistory } from 'vue-router';
import { adminSession } from '@/services/http';
import { useAdminStore } from '@/stores/admin';
import AdminLayout from '@/layouts/AdminLayout.vue';

const page = (path: string, component: () => Promise<unknown>, permission: string) => ({
  path, component, meta: { permission },
});
const routes = [
  { path: '/login', component: () => import('@/pages/LoginPage.vue'), meta: { public: true } },
  { path: '/403', component: () => import('@/pages/ForbiddenPage.vue'), meta: { public: true } },
  {
    path: '/', component: AdminLayout, children: [
      { path: '', redirect: '/dashboard' },
      { path: 'profile', component: () => import('@/pages/ProfilePage.vue') },
      page('dashboard', () => import('@/pages/DashboardPage.vue'), 'dashboard:read'),
      page('users', () => import('@/pages/UsersPage.vue'), 'users:read'),
      page('devices', () => import('@/pages/DevicesPage.vue'), 'devices:read'),
      page('orders', () => import('@/pages/OrdersPage.vue'), 'orders:read'),
      page('products', () => import('@/pages/ProductsPage.vue'), 'products:read'),
      page('tasks', () => import('@/pages/TaskAdminPage.vue'), 'tasks:read'),
      page('reminders', () => import('@/pages/RemindersPage.vue'), 'reminders:read'),
      page('content', () => import('@/pages/ContentPage.vue'), 'content:read'),
  page('nursery-rhymes', () => import('@/pages/NurseryRhymesPage.vue'), 'content:read'),
      page('story-library', () => import('@/pages/StoryLibraryPage.vue'), 'content:read'),
      page('poem-library', () => import('@/pages/PoemLibraryPage.vue'), 'content:read'),
      page('qa-library', () => import('@/pages/QaLibraryPage.vue'), 'content:read'),
      page('audits', () => import('@/pages/AuditsPage.vue'), 'audits:read'),
      page('ota', () => import('@/pages/OtaPage.vue'), 'ota:read'),
      page('wake-words', () => import('@/pages/WakeWordsPage.vue'), 'wake-words:read'),
      page('expressions', () => import('@/pages/ExpressionsPage.vue'), 'expressions:read'),
      page('voice-clones', () => import('@/pages/VoiceClonesPage.vue'), 'voice-clones:read'),
      page('speech', () => import('@/pages/SpeechMetricsPage.vue'), 'speech:read'),
      page('logs', () => import('@/pages/AuditLogsPage.vue'), 'system:operation-logs:read'),
      page('system/admins', () => import('@/pages/AdminUsersPage.vue'), 'system:admins:read'),
      page('system/roles', () => import('@/pages/AdminRolesPage.vue'), 'system:roles:read'),
      page('system/menus', () => import('@/pages/AdminMenusPage.vue'), 'system:menus:read'),
      page('system/login-logs', () => import('@/pages/LoginLogsPage.vue'), 'system:login-logs:read'),
      page('system/sessions', () => import('@/pages/OnlineSessionsPage.vue'), 'system:sessions:read'),
      page('system/dictionaries', () => import('@/pages/DictionariesPage.vue'), 'system:dictionaries:read'),
      page('system/parameters', () => import('@/pages/ParametersPage.vue'), 'system:parameters:read'),
      page('system/privacy', () => import('@/pages/PrivacyDeletionsPage.vue'), 'users:read'),
    ],
  },
];
const router = createRouter({ history: createWebHistory(), routes });
router.beforeEach(async to => {
  if (to.meta.public) return true;
  if (!adminSession.token()) return { path: '/login', query: { redirect: to.fullPath } };
  const store = useAdminStore();
  try {
    await store.loadIdentity();
  } catch {
    return { path: '/login', query: { redirect: to.fullPath } };
  }
  const permission = typeof to.meta.permission === 'string' ? to.meta.permission : undefined;
  return store.can(permission) ? true : '/403';
});
export default router;
